export const LOADING_FOUL_TYPE = "LOADING_FOUL_TYPE";
export const SAVE_LOADING_FOUL_TYPE = "SAVE_LOADING_FOUL_TYPE";
export const GET_FOUL_TYPE = "GET_FOUL_TYPE";
export const FORM_FAIL = "FORM_FAIL";
export const FOUL_TYPE_FAIL = "FOUL_TYPE_FAIL";

